import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';
import { logger } from 'src/utils/serverLogger';
import type { ReviewSummaryResponse } from './types/ReviewSummaryResponse';

const { publicRuntimeConfig } = getConfig() as NextConfig;

/**
 * The reviews-summary service keys products on catalogue id, which is the
 * public product code minus 10000. The offset is a property of this endpoint
 * alone: it must not leak to any other service call.
 */
export const PRODUCT_CODE_OFFSET = 10000;

// Reviews data is non-critical: the page renders without it, so it gets the
// tight budget and failures log at warn, not error. See the DISC-4325 spec's
// failure and latency policy.
export const TIMEOUT = 500;

export const fetchReviewSummary = async (
  productCode: number,
): Promise<ReviewSummaryResponse | null> => {
  const requestUrl = `${publicRuntimeConfig.endpoints.reviewSummary}/customer/${
    productCode - PRODUCT_CODE_OFFSET
  }`;

  const response = await fetchJSONWithTimeout(requestUrl, { timeout: TIMEOUT });

  switch (response.status) {
    case 200:
      return response.json();
    case 404:
      logger.warn('no AI summary found in reviews-summary service', { requestUrl });

      return null;
    default:
      logger.warn('error fetching AI summary from reviews-summary service', {
        requestUrl,
        status: response.status,
      });

      return null;
  }
};
